import React, { ReactElement, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Button, InputNumber, SelectPicker } from "rsuite";

import data from "./data.json";
import { TopSectionItem, TopSectionProps, TopSectionValue } from "./types";
import { LayoutCardName } from "../LayoutCards/types";
import {
  selectNumberOfPhotosOnIntro,
  selectTopSection,
  selectTopSectionPhotos,
} from "../../selectors";
import PickPhotosModal, { getPhotos } from "./PickPhotosModal";

const TopSection = ({
  id,
  activeLayout,
  onSectionChange,
  onNumberChange,
  onPhotosChange,
  onPhotosSave,
}: TopSectionProps): ReactElement => {
  const isTemplateV2 =
    activeLayout !== LayoutCardName.Classic &&
    activeLayout !== LayoutCardName.Gold;

  const topSection = useSelector(selectTopSection(id));
  const numberOfPhotosOnIntro = useSelector(selectNumberOfPhotosOnIntro(id));
  const topSectionPhotos = useSelector(selectTopSectionPhotos(id));

  const photos = useSelector((state: any) => state.tour[id].photos);

  const inputNumberRef = useRef(null);

  const [activeTopSection, setActiveTopSection] = useState<string>(
    topSection?.value
  );
  const [showModal, setShowModal] = useState<boolean>(false);
  const [selectedPhotos, setSelectedPhotos] = useState<any[]>(
    topSectionPhotos || []
  );

  const currentNumberOfPhotos = inputNumberRef?.current?.state?.value;

  useEffect(() => {
    onSectionChange(topSection);
    onNumberChange(numberOfPhotosOnIntro);
    onPhotosChange(topSectionPhotos);
  }, []);

  const filterData = (): TopSectionItem[] => {
    if (isTemplateV2) {
      return data;
    } else {
      return data.filter(
        (item) => item.value !== TopSectionValue.VimeoBackground
      );
    }
  };

  const handleChange = (item: TopSectionItem) => {
    setActiveTopSection(item.value);
    onSectionChange(item);
  };

  const handleSelectedPhotos = (photos: any) => {
    setSelectedPhotos(photos);
    onPhotosChange(photos);
    onPhotosSave(photos);
  };

  return (
    <>
      <SelectPicker
        size="md"
        placeholder="Select..."
        searchable={false}
        cleanable={false}
        defaultValue={topSection?.value}
        onChange={(val) =>
          handleChange(data.find(({ value }) => value === val))
        }
        data={filterData()}
        style={{
          marginBottom: 25,
          width: 400,
        }}
      />

      {isTemplateV2 && activeTopSection === TopSectionValue.FirstPhoto && (
        <>
          <div>
            <div style={{ marginBottom: 3 }}>Number of photos on Intro</div>
            <InputNumber
              ref={inputNumberRef}
              defaultValue={numberOfPhotosOnIntro}
              max={5}
              min={1}
              onChange={(val) => {
                onNumberChange(val);
                setSelectedPhotos([]);
              }}
              style={{ width: 100 }}
            />
            {selectedPhotos.length > 0 && (
              <div style={{ display: "flex", gap: 10, marginTop: 10 }}>
                {getPhotos(selectedPhotos).map((photo, index) => {
                  return (
                    <div key={photo.xs}>
                      <img
                        src={photo.xs}
                        alt={`p-${index}`}
                        style={{
                          width: 100,
                          height: 100,
                          borderRadius: 4,
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  );
                })}
              </div>
            )}
            <Button
              color="cyan"
              style={{ marginTop: 8 }}
              onClick={() => setShowModal(true)}
            >
              {selectedPhotos.length > 0 ? "Change" : "Select"} photo
              {currentNumberOfPhotos > 1 ? "s" : ""}
            </Button>
          </div>
          <PickPhotosModal
            showModal={showModal}
            setShowModal={setShowModal}
            currentNumberOfPhotos={currentNumberOfPhotos}
            photos={photos}
            initialPhotos={selectedPhotos}
            onSave={handleSelectedPhotos}
          />
        </>
      )}
    </>
  );
};

export default TopSection;
